export class TargetObject {
    targetObjectId: number;
    targetObjectName: string;
    acceptanceCriteria: string;
    businessDataOwnerName: string;
    businessDataOwnerNameValid: boolean;
    complexityEstimate: string;
    dataArchivalTypeId: number;
    dataClassification: string;
    dataClassificationDetailId: number;
    dataEncryption: string;
    dataHistoryBau: string;
    dataHistoryInitial: string;
    dataOwnerId: number;
    dataOwnerIdValid: boolean;
    dataRefreshFrequency: string;
    dataSetId: number;
    description: string;
    detailedInstructions: string;
    displayName: string;
    dmrtranslatorNotesTob: string;
    dmrscheduleTime: string;
    dmrstatus: string;
    objectHardDependency: string;
    objectSoftDependency: string;
    objectDqrequirement: string;
    jiraReferenceId: string;
    personalIdentifiableInformationId: number;
    praid: string;
    platformId: number;
    previousDataOwnerId: number;
    regionalScaleout: string;
    scheduleDependencies: string;
    scheduleFailAction: string;
    smenotesTob: string;
    sourceJoinConditions: string;
    targetObjectTypeId: number;
    techDeletePattern: string;
    techDeletePatternId: number;
    techDeleteDependencies: string;
    tofsreviewRename: string;
    tofsreviewCurName: string;
    uatfilterAttribute: string;
    dbLoadTypeId: number;
    loadDate: string;
    refreshDate: string;
    pkcheck: boolean;
    jobCompletionCheck: boolean;
    slacheck: boolean;
    isEditable: boolean;
    auditIsocountryKey: number;
    geoCoverageLevelId: number;
    geoCoverageValueCode: string;
    businessGroupCoverageCode: string;
    subFunctionCode: string;
    abstractionViewDetails: string;
    regionSegregatedYn: boolean;
    templateTobid: number;
    DeduplicateRecordsYN: boolean;
    EnableVaccum: boolean;
    Vaccumhours: number;
    DeleteConditionDetails: string;
    UserDefRegSegYN: boolean;

}
